<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus" circle @click="addGoods" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table ref="list" border :data="tableData" style="width: 100%" @row-click="rowClick" show-summary :summary-method="getSummaries">
      <!-- <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> -->
      <el-table-column prop="GoodsCode" label="条码" />
      <el-table-column prop="WarehouseName" label="仓库" width="130">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.WarehouseId"
            :disabled="readonly"
            :placeholder="readonly ? '' : '请选择'"
            :clearable="false"
            @change="count(row)"
            v-if="!readonly"
          >
            <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
          <span v-else>{{ row.WarehouseName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
            v-if="!readonly && info.CustomerId"
          />
          <!-- <span v-else>{{row.GoodsName}}</span> -->
          <span v-else>{{ info.CustomerId ? row.GoodsName : '请先选择客户' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="Quantity1" label="辅单位数量1" width="90px">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Quantity1"
            type="number"
            @input="count(row)"
            @blur="onBlur(row, 'Quantity1')"
            @focus="onFocus(row, 'Quantity1')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId1" label="辅单位1">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId1"
            :placeholder="readonly ? '' : '请选择'"
            :disabled="readonly"
            @change="unitChange(row, '1')"
          >
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Offer"
            type="number"
            @input="count(row)"
            v-if="!readonly"
            @blur="onBlur(row, 'Offer')"
            @focus="onFocus(row, 'Offer')"
          ></el-input>
          <span v-else>{{ row.Offer }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">{{ row.Price }}</template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90">
        <template slot-scope="{ row }">{{ row.NoTaxAmount }}</template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" width="150px">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" :disabled="!row.GoodsName" @input="count(row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="主单位数量" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="UnitId" label="主单位">
        <template slot-scope="{ row }">
          <el-select v-if="row.Units && row.Units.length" v-model="row.UnitId" :placeholder="readonly ? '' : '请选择'" :disabled="true">
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity2" label="辅单位数量2" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId2" label="辅单位2">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId2"
            :placeholder="readonly ? '' : '请选择'"
            :disabled="readonly"
            @change="unitChange(row, '2')"
          >
            <el-option v-for="(item, index) in row.Units" :key="index" :label="item.UnitName" :value="item.UnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " />

      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Discount"
            type="number"
            @blur="onBlur(row, 'Discount')"
            @focus="onFocus(row, 'Discount')"
            @input="count(row)"
            :disabled="!row.GoodsName"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Discount }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="CostPrice" label="成本">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.CostPrice"
            type="number"
            @blur="onBlur(row, 'CostPrice')"
            @focus="onFocus(row, 'CostPrice')"
            @input="changeNum(row)"
            v-if="!readonly && !row.CostPriceState"
          ></el-input>
          <span v-else>{{ row.CostPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="CostPriceState" label="确认成本">
        <template slot-scope="{ row }">
          <el-checkbox v-model="row.CostPriceState"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率/%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.TaxRate"
            type="number"
            @blur="onBlur(row, 'TaxRate')"
            @focus="onFocus(row, 'TaxRate')"
            @input="count(row)"
            :disabled="!row.GoodsName"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额">
        <template slot-scope="{ row }">{{ $commonJs.toThousands(row.TaxAmount) }}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">{{ $commonJs.toThousands(row.Amount) }}</template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" width="130px" v-if="!readonly">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right: 10px" @click.stop="copy(scope.row, scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click.stop="del(scope.row, scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import goodsDialog from '@/components/sales/business/listDialog'
import accountSelect from '@/components/sales/business/select'
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    goodsDialog,
    accountSelect
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      tableData: [
        {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: '',
          GoodsName: '',
          GoodsId: '',
          Model: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          BatchNo: '',
          Offer: 0,
          Discount: 100,
          Price: 0,
          CostPrice: 0,
          CostPriceState: false,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: '',
          Thumbnail: '',
          OutQuantity: 0,
          AddTime: ''
        }
      ],
      tableDel: [],
      multi: require('@/api/goods/multiUnit').default,
      sApi: require('@/api/goods/goods').default,
      api: require('@/api/sale/saBackDoc').default,
      wareApi: require('@/api/ba/warehouse').default,
      // saleApi: require("@/api/sale/sales").default,
      mallApi: require('@/api/sale/sales').default,
      docApi: require('@/api/sale/saDoc').default,
      account_api: require('@/api/goods/goods').default,
      PriAdjustGoodsList: [],
      wareList: [],
      nowIndex: 0,
      DAccount: [],
      DefTaxRate: 0,
      initTotal: 0,
      DefTaxRate: 0
    }
  },
  mounted() {
    this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7 }).then(res => {
      if (res.Code == 0) (this.DAccount = res.Data), (this.initDAccount = res.Data), (this.initTotal = res.Count)
    })
  },
  beforeMount() {
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
    })
  },
  methods: {
    unitChange(row, name) {
      console.log(row)
      row.Units.forEach(e => {
        if (e.UnitId == row['UnitId' + name]) {
          row['Rate' + name] = e.Rate
        }
      })
      this.count(row)
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    ChangeWarehouseId(id) {
      this.tableData.forEach(e => {
        e.WarehouseId = id
        e.T = e.T == 0 ? 0 : 1
      })
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage(val, row) {
      this.pageParams.pageIndex = val
      let GoodsName = row.GoodsName
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      row.GoodsName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    setDefTaxRate(DefTaxRate, type) {
      this.DefTaxRate = DefTaxRate
      if (DefTaxRate != null && type) {
        this.tableData.forEach(e => {
          e.TaxRate = this.DefTaxRate
          this.count(e)
        })
      }
    },
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity1', 'NoTaxAmount', 'Quantity2', 'Quantity', 'CostPrice', 'TaxAmount', 'Amount', 'Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            // 数量字段，保留4位小数
            if (['Quantity', 'Quantity1', 'Quantity2'].includes(field)) {
              sums[index] = Math.round(sums[index] * Math.pow(10, 4)) / Math.pow(10, 4)
            } else {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row)
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods()
        }
      }
    },
    onSelect(e, row) {
      if (!this.info.CustomerId) {
        this.$message.error('请选择客户')
      }
      this.sApi //获取客户报价，历史价
        .getGoodsOffer({ GoodsId: e.GoodsId, TradeUnitId: this.info.CustomerId, DocType: 1 })
        .then(res => {
          row.Offer = res.Data
          row.Price = res.Data
        })

      // this.setGoods(e,row)
      row.T = row.T == 0 ? 0 : 1
      // row.AccountId = e.AccountId;
      // row.GoodsName = e.GoodsName;
      row.OrderGoodsId = 0
      row.OrderId = this.info.OrderId || 0
      row.BarCode = e.BarCode
      row.GoodsCode = e.BarCode
      row.GoodsName = e.GoodsName
      row.GoodsId = e.GoodsId
      row.Model = e.Model || ''
      row.UnitId = e.UnitId || 0
      row.UnitName = e.MainUnitName || ''
      row.Quantity = 0
      row.Quantity1 = 0
      row.Quantity2 = 0
      row.BatchNo = e.BatchNo || ''
      // row.Offer = e.WholesalePrice || 0;
      row.Discount = 100
      // row.Price = e.WholesalePrice || 0;
      row.CostPrice = e.BalancePrice || 0
      row.CostPriceState = e.CostPriceState || false
      row.ExistQuantity = e.ExistQuantity || 0
      row.AvailableQuantity = e.AvailableQuantity || 0
      row.TaxRate = 0
      row.TaxAmount = 0
      row.Amount = 0
      row.NoTaxAmount = 0
      row.PromotionType = 0
      row.PromotionId = 0
      row.ReferenceCost = e.ReferenceCost || 0
      row.GrossProfit = 0
      row.Remark = e.Remark || ''
      row.Thumbnail = ''
      row.OutQuantity = 0
      row.AddTime = this.info.DocDate || today
      this.multi.list({ GoodsId: e.GoodsId }).then(res => {
        row.Units = res.Data
        res.Data.forEach(e => {
          if (e.IsMain) {
            row.UnitId = e.UnitId
            row.UnitId1 = e.UnitId
            row.Rate1 = e.Rate
          }
          if (row.UnitId2 == e.UnitId) {
            row.Rate2 = e.Rate
          }
        })
      })
    },
    getData() {
      this.tableData = []
      this.info.Goods.forEach(e => {
        if (e.UnitId == 0) {
          e.UnitId = null
        }
        if (e.UnitId1 == 0) {
          e.UnitId1 = null
        }
        if (e.UnitId2 == 0) {
          e.UnitId2 = null
        }
        e.T = null
        e.Units.forEach(v => {
          if (e.UnitId1 == v.UnitId) e.Rate1 = v.Rate
          if (e.UnitId2 == v.UnitId) e.Rate2 = v.Rate
        })
      })
      if (!this.readonly) {
        this.tableData = this.info.Goods
      } else {
        if (this.info.Goods.length > 0) {
          this.tableData = this.info.Goods
        } else {
          this.addGoods()
        }
      }

      this.subTable()
    },
    // getDataFromOrder(id) {
    //   this.saleApi.getGoodsList(id).then((res) => {
    //     this.tableData.forEach(item => {
    //       if(item.T !== 0) {
    //         item.T = 2
    //         this.tableDel.push(item)
    //       }
    //     })
    //     res.Data.forEach(item => {
    //       item.T = 0;
    //       item.DocGoodsId = 0;
    //       item.DocId = this.info.DocId || 0;
    //       item.OrderGoodsId = 0;
    //       item.OrderId = 0;
    //       item.AddTime = this.info.DocDate || today;
    //       item.WarehouseId = null
    //       this.count(item,true)
    //     })
    //     this.tableData = res.Data;
    //   });
    // },
    getDataFromOrder(id) {
      this.mallApi.getGoodsList(id).then(res => {
        this.tableData.forEach(item => {
          if (item.T !== 0) {
            item.T = 2
            this.tableDel.push(item)
          }
        })
        res.Data.forEach(item => {
          item.T = 0
          item.DocGoodsId = 0
          item.DocId = this.info.DocId || 0
          item.OrderGoodsId = 0
          item.OrderId = 0
          item.AddTime = this.info.DocDate || today
          item.WarehouseId = null
          this.multi.list({ GoodsId: item.GoodsId }).then(res => {
            item.Units = res.Data
            res.Data.forEach(e => {
              if (e.IsMain) {
                item.UnitId = e.UnitId
                item.UnitId1 = e.UnitId
                item.Rate1 = e.Rate
              }
              if (item.UnitId2 == e.UnitId) {
                item.Rate2 = e.Rate
              }
            })
            this.count(item, true)
          })
        })
        this.tableData = res.Data
      })
    },
    getDataFromDoc(id) {
      this.docApi.getGoodsList(id).then(res => {
        this.tableData.forEach(item => {
          if (item.T !== 0) {
            item.T = 2
            this.tableDel.push(item)
          }
        })
        res.Data.forEach(item => {
          item.T = 0
          item.DocGoodsId = 0
          item.DocId = this.info.DocId || 0
          item.AddTime = this.info.DocDate || today
          item.WarehouseId = null
          this.multi.list({ GoodsId: item.GoodsId }).then(res => {
            item.Units = res.Data
            res.Data.forEach(e => {
              if (e.IsMain) {
                item.UnitId = e.UnitId
                item.UnitId1 = e.UnitId
                item.Rate1 = e.Rate
              }
              if (item.UnitId2 == e.UnitId) {
                item.Rate2 = e.Rate
              }
            })
            this.count(item, true)
          })
        })
        this.tableData = res.Data
      })
    },
    setRow() {
      // this.tableData.push({T: 0})
      let ids = this.PriAdjustGoodsList.map(x => x.GoodsId)
      this.$refs.goodsDialog.open().then(that => {
        that.getData({ Status: 1, NotIds: ids })
      })
    },
    del(row, index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2
          this.tableDel.push(row)
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1)
          this.addGoods()
        } else {
          this.tableData.splice(index, 1)
        }
        this.subTable()
      })
    },
    copy(row, index) {
      this.tableData.splice(index, 0, {
        ...row
      })
      this.tableData[index].OrderGoodsId = 0
      this.tableData[index].T = 0
      this.subTable()
    },
    addGoods(row, index) {
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: '',
        GoodsName: '',
        GoodsId: '',
        Model: '',
        UnitId: null,
        UnitName: '',
        UnitId1: null,
        UnitId2: null,
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: '',
        Offer: 0,
        Discount: 100,
        Price: 0,
        CostPrice: 0,
        CostPriceState: false,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: this.DefTaxRate,
        TaxAmount: 0,
        Amount: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: '',
        Thumbnail: '',
        OutQuantity: 0,
        AddTime: '',
        WarehouseId: this.info.WarehouseId
      }
      this.tableData.push(goods)
    },
    setGoods(e) {
      let date = new Date()
      let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      this.sApi.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate }).then(res => {
        var now_item = this.tableData[this.nowIndex]
        let goods = {
          T: 0,
          DocGoodsId: 0,
          DocId: this.info.DocId || 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          WarehouseId: now_item ? now_item.WarehouseId : null,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || '',
          UnitName: e.MainUnitName || '',
          UnitId: e.UnitId,
          UnitId1: e.UnitId1,
          UnitId2: e.UnitId2,
          Rate1: 0,
          Rate2: 0,
          // UnitName: e.MainUnitName || "",
          Quantity: e.Quantity,
          Quantity1: e.Quantity,
          Quantity2: null,
          BatchNo: e.BatchNo || '',
          Offer: 0,
          Discount: 100,
          Price: e.WholesalePrice || 0,
          CostPrice: e.BalancePrice || 0,
          CostPriceState: e.CostPriceState || false,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || '',
          Thumbnail: '',
          BackQuantity: 0,
          AddTime: this.info.DocDate || today,
          Units: []
        }
        if (res.Data != null) {
          goods.Offer = res.Data.VirtualPrice
        }
        this.multi.list({ GoodsId: e.GoodsId }).then(res => {
          goods.Units = res.Data
          res.Data.forEach(x => {
            if (x.IsMain) {
              goods.UnitId = x.UnitId
              goods.UnitId1 = x.UnitId
              goods.Rate1 = x.Rate
            }
            if (goods.UnitId2 == x.UnitId) {
              goods.Rate2 = x.Rate
            }
          })
        })
        // this.tableData.splice(this.nowIndex,1,goods)
        this.tableData.push(goods)
        this.subTable()
      })
    },
    count(row, keep = false) {
      let price = row.Price ? Number(row.Price) : 0
      let dis = row.Discount > 0 ? Number(row.Discount) : 100
      let qua = row.Quantity1 ? Number(row.Quantity1) : 0
      let rate = row.TaxRate ? Number(row.TaxRate) : 0
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0
      if (row.T !== 0 && !keep) row.T = 1

      if (row.Quantity1 > 0) {
        row.Quantity1 = 0 - row.Quantity1
        qua = row.Quantity1
      }

      row.Price = dis ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2) : (row.Offer * (1 + rate / 100)).toFixed(2)
      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2)
      row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity1).toFixed(2)
      row.TaxAmount = ((qua * (((dis ? row.Offer * (dis / 100) : row.Offer) * rate) / 100) * 100) / 100).toFixed(2) || 0
      row.GrossProfit = (row.Amount - qua * ref).toFixed(2)
      row.Quantity = (1 / row.Rate1 ? row.Rate1 : 1) * qua
      if (row.UnitId2 == row.UnitId) {
        row.Quantity2 = row.Quantity
      } else {
        if (!row.Rate2) {
          row.Quantity2 = 0
        } else {
          row.Quantity2 = (row.Rate2 ? row.Rate2 : 1) * row.Quantity
        }
      }
      this.subTable()
    },
    subTable() {
      this.$emit('getList', this.tableData.concat(this.tableDel))
    }
  }
}
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
